import routes from "@/libs/endPoint/rh/servidorRoutes.js";
import routesBancoHoras from "@/libs/endPoint/rh/LancamentoBancoHorasRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
import RemocaoServices from "./RemocaoServices";
import store from "@/store/index.js";
class ServidorServices {
  constructor() {
    this.routes = routes;
    this.routesBancoHoras = routesBancoHoras;
    this.ApiServices = ApiServices;
    this.RemocaoServices = RemocaoServices;
    this.store;
  }

  async saldoBancoHoras(pkpessoa, ano) {
    try {
      const url = this.routesBancoHoras.saldoTotal;
      const { data } = await ApiServices.get(url, { pkpessoa, ano });
      store.commit("storeServidor/setSaldoBancoHoras", Array.isArray(data) ? data : data.data || []);
      return data;
    } catch (error) {
      console.error("Erro ao buscar saldo banco de horas:", error);
      throw error;
    }
  }

  async lancamentosMatriculas(id_matricula, ano) {
    try {
      const url = this.routesBancoHoras.main;
      const { data } = await ApiServices.get(url, { id_matricula, ano });
      const lista = Array.isArray(data) ? data : data.data || [];
      store.commit("storeServidor/setLancamentosBancoHoras", lista);
      return lista;
    } catch (error) {
      console.error("Erro ao buscar lançamentos do banco de horas:", error);
      throw error;
    }
  }

  async validarServidor(cpf, ano) {
    try {
      return this.RemocaoServices.validarServidor(cpf, ano);
    } catch (error) {
      console.error("Erro ao validar servidor:", error);
      throw error;
    }
  }
  async alterarEmail(pkpessoa, email) {
    try {
      const url = this.routes.alterarEmail;
      const { data } = await ApiServices.put(url, { pkpessoa, email });
      return data;
    } catch (error) {
      console.error("Erro ao alterar e-mail:", error);
      throw error;
    }
  }

  async getServidor(params) {
    try {
      const url = this.routes.busca;

      const { data } = await this.ApiServices.get(url, params);
      if (data.success) {
        store.commit("storeServidor/setServidor", data.data);
      }
      return data;
    } catch (error) {
      console.error("Erro ao obter servidor:", error);
      throw error;
    }
  }
  async listarServidor(params) {
    try {
      const url = this.routes.main;

      const { data } = await this.ApiServices.get(url, params);

      return data;
    } catch (error) {
      console.error("Erro ao obter servidor:", error);
      throw error;
    }
  }
}

export default new ServidorServices();
